/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'monetization';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/product/in-app
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ProductResource+type:symbol+getActiveProductsWithVersionsInAppLegacy&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Product-get-%2Fmonetization%2Fv3%2Fproduct%2Fin-app'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fproduct%2Fin-app?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getActiveProductsWithVersionsInAppLegacyRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/product/in-app'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/currency
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:CurrencyResource+type:symbol+getInAppCurrencyResponse&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Currency-get-%2Fmonetization%2Fv3%2Fcurrency'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fcurrency?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getCurrencyRequestRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/currency'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/phone-numbers/in-app/{preferredLanguage}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:PhoneNumbersResource+type:symbol+getInAppPhoneNumber&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Phone_Numbers-get-%2Fmonetization%2Fv3%2Fphone-numbers%2Fin-app%2F%7BpreferredLanguage%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fphone-numbers%2Fin-app%2F%28%28%7BpreferredLanguage%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getInAppPhoneNumberRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/phone-numbers/in-app', pathParameterPlaceholder]),
  pathParameters: freeze(['preferredLanguage'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/product/owned-products
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ProductResource+type:symbol+getOwnedProducts&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Product-get-%2Fmonetization%2Fv3%2Fproduct%2Fowned-products'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fproduct%2Fowned-products?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getOwnedProductsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/product/owned-products'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/currency/public/{browserLocale}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:CurrencyResource+type:symbol+getPublicCurrencyResponse&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Currency-get-%2Fmonetization%2Fv3%2Fcurrency%2Fpublic%2F%7BbrowserLocale%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fcurrency%2Fpublic%2F%28%28%7BbrowserLocale%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getPublicCurrencyResponseRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/currency/public', pathParameterPlaceholder]),
  pathParameters: freeze(['browserLocale'])
});